import { MediaSearchPanel, SearchMode } from 'components/Composer/MediaSearchPanel'

interface SearchTabProps {
  onClose: () => void
  onVideoUrlAdded: () => void
  mode: SearchMode
  onSearchSubmit?: () => void
}

export function SearchTab(props: SearchTabProps) {
  return (
    <MediaSearchPanel
      onClose={props.onClose}
      onVideoUrlAdded={props.onVideoUrlAdded}
      mode={props.mode}
      onSearchSubmit={props.onSearchSubmit}
    />
  )
}

export default SearchTab
